import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import ImageButtonList from '../common/imageButtonList';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';
import './styles.css';

class SoftKnockPopup extends Component {
  /**************
   * Properties *
   **************/
  state = {
    buttons: [
      {
        id: 'accept-call',
        to: '/telehealth/call',
        highlight: require('./images/Accept-Call-HL.png'),
        unhighlight: require('./images/Accept-Call-UH.png'),
        alt: 'Accept Call',
      },
      {
        id: 'decline-call',
        to: '/main_menu',
        highlight: require('./images/Decline-Call-HL.png'),
        unhighlight: require('./images/Decline-Call-UH.png'),
        alt: 'Decline Call',
      },
    ],
    popup: {
      id: 'popup',
      src: require('./images/Popup.png'),
    },
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns { React.Component }  The rendered view of the component.
   *
   */
  render() {
    return (
      <div className="softknock-popup">
        <ImageText {...this.state.popup} top="-28.6" left="-5.2" unit="rem" />
        <ImageButtonList imageButtons={this.state.buttons} />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}
const ConnectedSoftKnockPopup = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(SoftKnockPopup);

export default withRouter(ConnectedSoftKnockPopup);
